export const ModeFraisNature = [
  'Pedagogique',
  'Annexe',
] as const

export type ModeFraisNature = typeof ModeFraisNature[number]

export const ModeFraisNatureLibelle: {
  [key in ModeFraisNature]: string
} = {
  Pedagogique: 'Pédagogique',
  Annexe: 'Annexe',
} as const
